import { SetStateAction, useCallback, useContext, useEffect, useState } from "react";
import { Checkbox, FormControlLabel, FormGroup, MenuItem, Paper, Select, Snackbar, TableContainer, TextField, Toolbar, Typography } from "@mui/material";
import React from "react";
import { CustomTextField, CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import { useLocation } from "react-router-dom";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { IZonaHomogenea } from "../../../Interfaces/cadernos/zona_homogenea";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { Alert } from "../../../Components/Alert/Alert";
import LoadingVulpesSmall from "../../../Styles/Loader/loadingSmall";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { ICabecalho8 } from "../../../Interfaces/cadernos/caderno8";
import BasicPopover from "../../../Components/Popover";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";

interface CabecalhoForm_prop {
  set_obj_anexo_cabecalho_selecionado: React.Dispatch<SetStateAction<ICabecalho8 | undefined>>;
  obj_anexo_cabecalho_selecionado: ICabecalho8 | undefined;
}

export const CabecalhoForm: React.FC<CabecalhoForm_prop> = ({
  obj_anexo_cabecalho_selecionado
  , set_obj_anexo_cabecalho_selecionado }) => {
  const auth = useContext(AuthContext);

  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [especie_ou_lote_homegenio_selecionada, set_especie_ou_lote_homegenio_selecionada] = useState<IZonaHomogenea>();
  const [especie_ou_lote_homegenio_lista, set_especie_ou_lote_homegenio_lista] = useState<IZonaHomogenea[]>([]);
  const [cultura_selecionada, set_cultura_selecionada] = useState<any>();

  const [obj_anexo_cabecalho, set_obj_anexo_cabecalho] = useState<ICabecalho8>();
  const [obj_anexo_cabecalho_lista, set_obj_anexo_cabecalho_lista] = useState<ICabecalho8[]>();
  const [obj_anexo_cabecalho_to_edit, set_obj_anexo_cabecalho_to_edit] = useState<ICabecalho8>();
  const [obj_anexo_cabecalho_backup, set_obj_anexo_cabecalho_backup] = useState<ICabecalho8 | undefined>(undefined);

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);

  const [flag_editar_cabecalho, set_flag_editar_cabecalho] = useState(false)

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [error_produca_total, set_error_produca_total] = React.useState(false);
  const [error_esperada, set_error_esperada] = React.useState(false);
  const [error_obtida, set_error_obtida] = React.useState(false);
  const [error_n_contador, set_error_n_contador] = React.useState(false);
  const [error_leitura_contador_preimeira, set_error_leitura_contador_preimeira] = React.useState(false);
  const [error_n_planta, set_error_n_planta] = React.useState(false);

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);
  const [isEditingCultura, setIsEditingCultura] = useState(false);

  const handleCloseDialog = () => {


    set_error_esperada(false)
    set_error_leitura_contador_preimeira(false)
    set_error_n_contador(false)
    set_error_obtida(false)
    set_error_produca_total(false)
    set_error_n_planta(false)
    set_obj_anexo_cabecalho_to_edit(undefined)

    if (obj_anexo_cabecalho_backup) {
      set_obj_anexo_cabecalho_to_edit(obj_anexo_cabecalho_backup); // restaura o estado original
    }
    set_flag_editar_cabecalho(false)
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };

  const onInputEditTableChange_cabecalho = (event: any) => {
    const { name, value, type, checked } = event.target;
    //let aux_obj_anexo: any = obj_anexo_cabecalho_to_edit === undefined ? {} : obj_anexo_cabecalho_to_edit
    set_flag_editado(true)

    if (type === "checkbox") {
      set_obj_anexo_cabecalho_to_edit((old: any) => ({
        ...old,
        [name]: checked,
      }));
    } else {
      if (name === 'produca_total') {
        if (!/^\d+$/.test(value)) {
          set_error_produca_total(true)
        } else {
          set_error_produca_total(false)
        }
      }
      if (name === 'esperada') {
        if (!/^\d+$/.test(value)) {
          set_error_esperada(true)
        } else {
          set_error_esperada(false)
        }
      }
      if (name === 'obtida') {
        if (!/^\d+$/.test(value)) {
          set_error_obtida(true)
        } else {
          set_error_obtida(false)
        }
      }
      if (name === 'n_planta') {
        if (!/^\d+$/.test(value)) {
          set_error_n_planta(true)
        } else {
          set_error_n_planta(false)
        }
      }
      if (name === 'leitura_contador_preimeira') {
        if (!/^\d+$/.test(value)) {
          set_error_leitura_contador_preimeira(true)
        } else {
          set_error_leitura_contador_preimeira(false)
        }
      }
      if (name === 'n_contador') {
        if (!/^\d+$/.test(value)) {
          set_error_n_contador(true)
        } else {
          set_error_n_contador(false)
        }
      }


      set_obj_anexo_cabecalho_to_edit((old: any) => ({
        ...old,
        [name]: value,
      }));
    }
  };

  const handleCloseSnack = () => {
    setOpenSnackSuccess(false);
    setOpenSnackError(false);
  };
  const atualizarListaZonasComCabecalhos = (
    listaZonas: any[],
    listaCabecalhos: ICabecalho8[]
  ) => {
    const resultado = listaZonas.map((zona) => ({
      ...zona,
      culturas: [...(zona.culturas ?? [])],
    }));

    listaCabecalhos.forEach((item: ICabecalho8) => {
      const zona = resultado.find(
        (z) => z.zona_homogenea === item.zona_homo
      );

      const novaCultura = {
        cultura: item.cultura,
        area: item.area,
      };

      if (!zona) {
        resultado.push({
          zona_homogenea: item.zona_homo,
          culturas: [novaCultura],
        });
      } else {
        const culturaExiste = zona.culturas.some(
          (c: any) => c.cultura === item.cultura
        );

        if (!culturaExiste) {
          zona.culturas.push(novaCultura);
        }
      }
    });

    return resultado;
  };

  const get_info = useCallback(async () => {
    try {
      let res = await get(auth.token.cookie_token, `/zona_homgenea_caraterizacao/${location.state.id_rosto}`);
      let res_cabecalho = await get(auth.token.cookie_token, `/get_reg_pos_colheita_oito_cabecalho_rosto/${location.state.id_rosto}`);

      if (res.status === 200 && res_cabecalho.status === 200) {
        if (res.data.result.length !== 0) {
          const resultado = atualizarListaZonasComCabecalhos(
            res.data.result,
            res_cabecalho.data.result
          );
          set_especie_ou_lote_homegenio_lista(resultado);
          set_especie_ou_lote_homegenio_selecionada(resultado[0]);
          set_cultura_selecionada(resultado[0].culturas[0])

          if (res_cabecalho.data.result.length !== 0) {

            set_obj_anexo_cabecalho_lista(res_cabecalho.data.result);
            let obj_aux = res_cabecalho.data.result?.find((el: ICabecalho8) => el.zona_homo === resultado[0].zona_homogenea);

            if (obj_aux === undefined) {

              set_flag_editar_cabecalho(true)

            } else {
              set_obj_anexo_cabecalho_to_edit(obj_aux);
              set_obj_anexo_cabecalho_selecionado(obj_aux);
              set_obj_anexo_cabecalho_backup(obj_aux);
              set_obj_anexo_cabecalho(obj_aux);
              set_cultura_selecionada(resultado[0].culturas.find((el: any) => el.cultura === obj_aux.cultura))

            }

          } else {
            set_flag_editar_cabecalho(true);
          }
        } else {
          set_flag_editar_cabecalho(true);
        }
      }

      setIsLoading(false);
    } catch (error) {
      func_print("get_info", error, true);
      setMessage("Erro!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }, [
    auth.token.cookie_token,
    location.state.id_rosto,
    set_obj_anexo_cabecalho_selecionado,
  ]);

  const handle_change_cultura = (cultura_selecionad: string) => {

    let aux_cultura_selecionada = especie_ou_lote_homegenio_selecionada?.culturas.find((el: any) => el.cultura === cultura_selecionad)

    set_cultura_selecionada(aux_cultura_selecionada)

    let obj_aux = obj_anexo_cabecalho_lista?.find((el: ICabecalho8) => el.zona_homo === especie_ou_lote_homegenio_selecionada?.zona_homogenea && aux_cultura_selecionada.cultura === el.cultura)

    if (obj_aux === undefined) {
      set_flag_editar_cabecalho(true)
    } else {
      set_flag_editar_cabecalho(false)


    }
    set_obj_anexo_cabecalho(obj_aux)
    set_obj_anexo_cabecalho_to_edit(obj_aux)
    set_obj_anexo_cabecalho_selecionado(obj_aux)

  }


  const handle_change_zona_homogenea = (zona_homogenea_selecionada: string) => {
    set_obj_anexo_cabecalho_selecionado(undefined)

    let aux_obj_zona_homogenea_selecionada = especie_ou_lote_homegenio_lista.find((el: IZonaHomogenea) => el.zona_homogenea === zona_homogenea_selecionada)

    set_especie_ou_lote_homegenio_selecionada(aux_obj_zona_homogenea_selecionada)
    let obj_aux = obj_anexo_cabecalho_lista?.find((el: ICabecalho8) => el.zona_homo === zona_homogenea_selecionada)
    if (obj_aux === undefined) {
      set_flag_editar_cabecalho(true)
      set_cultura_selecionada(aux_obj_zona_homogenea_selecionada?.culturas[0])

    } else {
      set_flag_editar_cabecalho(false)
      set_cultura_selecionada(aux_obj_zona_homogenea_selecionada?.culturas.find((el) => el.cultura === obj_aux?.cultura))

    }
    set_obj_anexo_cabecalho(obj_aux)
    set_obj_anexo_cabecalho_to_edit(obj_aux)
    set_obj_anexo_cabecalho_selecionado(obj_aux)


  }

  const handle_criar_cabecalho = async () => {
    if (error_produca_total || error_esperada || error_obtida || error_n_planta || error_n_contador || error_leitura_contador_preimeira) {
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

    } else {

      try {
        setIsLoading(true);

        let data = await post(auth.token.cookie_token, "new_reg_pos_colheita_oito_cabecalho", {
          payload: {
            id_registo_colh: 0,
            zona_homo: especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? null : especie_ou_lote_homegenio_selecionada?.zona_homogenea,
            area: cultura_selecionada?.area === undefined ? null : cultura_selecionada?.area,
            cultura: cultura_selecionada?.cultura === undefined ? null : cultura_selecionada?.cultura,
            compasso: obj_anexo_cabecalho_to_edit?.compasso === undefined ? null : obj_anexo_cabecalho_to_edit?.compasso,
            produca_total: obj_anexo_cabecalho_to_edit?.produca_total === undefined ? null : obj_anexo_cabecalho_to_edit?.produca_total,
            esperada: obj_anexo_cabecalho_to_edit?.esperada === undefined ? null : obj_anexo_cabecalho_to_edit?.esperada,
            c1: obj_anexo_cabecalho_to_edit?.c1 === undefined ? null : obj_anexo_cabecalho_to_edit?.c1,
            c2: obj_anexo_cabecalho_to_edit?.c2 === undefined ? null : obj_anexo_cabecalho_to_edit?.c2,
            c3: obj_anexo_cabecalho_to_edit?.c3 === undefined ? null : obj_anexo_cabecalho_to_edit?.c3,
            porta_enxerto: obj_anexo_cabecalho_to_edit?.porta_enxerto === undefined ? null : obj_anexo_cabecalho_to_edit?.porta_enxerto,
            n_planta: obj_anexo_cabecalho_to_edit?.n_planta === undefined ? null : obj_anexo_cabecalho_to_edit?.n_planta,
            data_plantacao: obj_anexo_cabecalho_to_edit?.data_plantacao === undefined ? null : obj_anexo_cabecalho_to_edit?.data_plantacao,
            obtida: obj_anexo_cabecalho_to_edit?.obtida === undefined ? null : obj_anexo_cabecalho_to_edit?.obtida,
            id_rosto: location.state.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ""
          }
        })
        if (data.status === 200) {
          setMessage("Operação efetuada com sucesso!");
          setOpenSnackSuccess(true);
          set_obj_anexo_cabecalho(data.data.result)
          set_obj_anexo_cabecalho_to_edit(data.data.result)
          if (obj_anexo_cabecalho_lista?.length === 0 || obj_anexo_cabecalho_lista === undefined) {
            set_obj_anexo_cabecalho_lista([data.data.result])

          } else {
            set_obj_anexo_cabecalho_lista((old: any) => [...old, data.data.result])

          }
          set_error_esperada(false)
          set_error_obtida(false)
          set_error_leitura_contador_preimeira(false)
          set_error_n_contador(false)
          set_error_produca_total(false)
          set_error_n_planta(false)
          set_flag_editado(false)

          set_obj_anexo_cabecalho_to_edit(data.data.result)
          set_obj_anexo_cabecalho_selecionado(data.data.result)
          set_flag_editar_cabecalho(false)
          set_obj_anexo_cabecalho_backup(data.data.result)

          set_obj_anexo_cabecalho(data.data.result)

        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }
        setIsLoading(false);

      } catch (error) {
        func_print('handle_criar_cabecalho', error, true)
        setIsLoading(false);

        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
    }

  }
  const handle_editar_cabecalho = async () => {
    if (error_produca_total || error_esperada || error_obtida || error_n_planta || error_n_contador || error_leitura_contador_preimeira) {
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

    } else {
      try {
        setIsLoading(true);

        let data = await post(auth.token.cookie_token, "update_reg_pos_colheita_oito_cabecalho", {
          payload: {
            id_registo_colh: obj_anexo_cabecalho_to_edit?.id_registo_colh,
            zona_homo: especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? null : especie_ou_lote_homegenio_selecionada?.zona_homogenea,
            area: cultura_selecionada?.area === undefined ? null : cultura_selecionada?.area,
            cultura: cultura_selecionada?.cultura === undefined ? null : cultura_selecionada?.cultura,
            compasso: obj_anexo_cabecalho_to_edit?.compasso === undefined ? null : obj_anexo_cabecalho_to_edit?.compasso,
            produca_total: obj_anexo_cabecalho_to_edit?.produca_total === undefined ? null : obj_anexo_cabecalho_to_edit?.produca_total,
            esperada: obj_anexo_cabecalho_to_edit?.esperada === undefined ? null : obj_anexo_cabecalho_to_edit?.esperada,
            c1: obj_anexo_cabecalho_to_edit?.c1 === undefined ? null : obj_anexo_cabecalho_to_edit?.c1,
            c2: obj_anexo_cabecalho_to_edit?.c2 === undefined ? null : obj_anexo_cabecalho_to_edit?.c2,
            c3: obj_anexo_cabecalho_to_edit?.c3 === undefined ? null : obj_anexo_cabecalho_to_edit?.c3,
            porta_enxerto: obj_anexo_cabecalho_to_edit?.porta_enxerto === undefined ? null : obj_anexo_cabecalho_to_edit?.porta_enxerto,
            n_planta: obj_anexo_cabecalho_to_edit?.n_planta === undefined ? null : obj_anexo_cabecalho_to_edit?.n_planta,
            data_plantacao: obj_anexo_cabecalho_to_edit?.data_plantacao === undefined ? null : obj_anexo_cabecalho_to_edit?.data_plantacao,
            obtida: obj_anexo_cabecalho_to_edit?.obtida === undefined ? null : obj_anexo_cabecalho_to_edit?.obtida,
            id_rosto: location.state.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ""
          }
        })


        if (data.status === 200) {
          setMessage("Operação efetuada com sucesso!");
          setOpenSnackSuccess(true);
          set_flag_editar_cabecalho(false)
          set_error_esperada(false)
          set_error_obtida(false)
          set_error_leitura_contador_preimeira(false)
          set_error_n_contador(false)
          set_error_produca_total(false)
          set_error_n_planta(false)
          set_flag_editado(false)
          set_obj_anexo_cabecalho_to_edit(data.data.result)
          set_obj_anexo_cabecalho(data.data.result)
          set_obj_anexo_cabecalho_selecionado(data.data.result)
          set_obj_anexo_cabecalho_backup(data.data.result)
          let aux = obj_anexo_cabecalho_lista?.map((el) => {
            if (el.id_registo_colh === data.data.result.id_registo_colh) {
              return data.data.result
            } else {
              return el
            }
          })
          set_obj_anexo_cabecalho_lista(aux)
        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print('handle_editar_cabecalho', error, true)
        setIsLoading(false);

        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
    }

  }
  const handle_delete_cabecalho = async () => {
    try {
      set_open_dialog_tem_a_certeza_que_quer_eliminar(false)
      setIsLoading(true);
      let data = await del(auth.token.cookie_token, `delete_pos_colheita_oito_cabecalho/${obj_anexo_cabecalho?.id_registo_colh}`)
      if (data.status === 200) {
        func_print('obj_anexo_cabecalho_lista', obj_anexo_cabecalho_lista)
        let lista_aux: any = obj_anexo_cabecalho_lista?.filter((el) =>
          el.id_registo_colh !== obj_anexo_cabecalho?.id_registo_colh
        );
        setMessage("Eliminado com sucesso!");
        setOpenSnackSuccess(true);
        set_obj_anexo_cabecalho_lista(lista_aux === undefined ? [] : lista_aux)
        set_obj_anexo_cabecalho_selecionado(undefined)
        set_obj_anexo_cabecalho(undefined)
        set_obj_anexo_cabecalho_to_edit(undefined)
        set_obj_anexo_cabecalho_backup(undefined)
        set_flag_editar_cabecalho(true)
      } else {
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {

      func_print('handle_delete_cabecalho', error, true)
      setIsLoading(false);

      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
    }
  }

  useEffect(() => {
    get_info();
  }, [get_info]);

  return (
    <form>
      <CustomThemeProvider>
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{
            height: "auto",
            width: "auto",
            margin: 2,
            padding: 2,
          }}
        >
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          {isLoading ?
            <LoadingVulpesSmall />
            :
            <Toolbar
              style={{
                paddingTop: 3,
                paddingBottom: 10,
                fontFamily: "candara",
                display: "flex",
                flexDirection: 'column',
              }}
            >
              <div style={{
                width: '100%',

              }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: 'row',
                  }}
                >
                  <h1
                    style={{
                      fontWeight: 600,
                      fontSize: 20,
                      fontFamily: "candara",
                    }}
                  >
                    8 - Registo de Pós-colheita
                  </h1>
                  <BasicPopover
                    text={
                      "Preencher apenas no caso do beneficiário ter compromisso ativo na intervenção Agricultura Biológica ou PRODI. \n\nPretende-se que neste quadro sejam registadas todas as operações de processamento e comercialização quando tal seja realizado diretamente pelo produtor"
                    }
                  />
                </div>
                <div style={{
                  width: '100%',
                  display: "flex",
                  flexDirection: 'row',
                  alignItems: 'flex-end',
                  justifyContent: 'flex-end',

                }}>
                  {
                    especie_ou_lote_homegenio_lista.length === 0 ? <></> :


                      obj_anexo_cabecalho === undefined ?
                        is_historico === true ? <></> :

                          <ButtonCadernos

                            mostrarBotaoGravar
                            aoClicarGravar={() => { handle_criar_cabecalho() }}
                          />
                        :
                        flag_editar_cabecalho === true ?
                          <ButtonCadernos
                            mostrarBotaoCancelar
                            aoClicarCancelar={() => {
                              if (flag_editado) {
                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                              } else {
                                set_error_esperada(false)
                                set_error_leitura_contador_preimeira(false)
                                set_error_n_contador(false)
                                set_error_obtida(false)
                                set_error_produca_total(false)
                                set_error_n_planta(false)
                                set_obj_anexo_cabecalho_to_edit(undefined)

                                if (obj_anexo_cabecalho_backup) {
                                  set_obj_anexo_cabecalho_to_edit(obj_anexo_cabecalho_backup); // restaura o estado original
                                }
                                set_flag_editar_cabecalho(false)
                              }
                            }}
                            mostrarBotaoGravar
                            aoClicarGravar={() => { handle_editar_cabecalho() }}
                          /> :
                          is_historico === true ? <></> :

                            <ButtonCadernos
                              mostrarBotaoApagar
                              mostrarBotaoEditar
                              aoClicarApagar={() => { set_open_dialog_tem_a_certeza_que_quer_eliminar(true) }}
                              aoClicarEditar={() => { set_flag_editar_cabecalho(true) }}
                            />


                  }
                </div>
                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',

                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.3,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    Zona Homogénea
                    <Select
                      value={especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? '' : especie_ou_lote_homegenio_selecionada?.zona_homogenea}
                      label={''}
                      name={'zona_homogenea'}
                      sx={{
                        fontSize: 14,
                        fontFamily: "verdana",
                        minWidth: 200,
                      }}
                      onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                    >

                      {especie_ou_lote_homegenio_lista
                        ?.filter((item: any) => item?.zona_homogenea)
                        .sort((a, b) =>
                          (a.zona_homogenea ?? '').localeCompare(b.zona_homogenea ?? '', 'pt', {
                            sensitivity: 'base',
                          })
                        ).map((item: IZonaHomogenea, key) => {

                          return (
                            <MenuItem key={key} value={item.zona_homogenea}>
                              <Typography
                                style={{
                                  fontSize: 14,
                                  fontFamily: "candara",
                                }}
                              >
                                {item.zona_homogenea}
                              </Typography>
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.2,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    <BasicPopover
                      text={
                        "Exploração em conversão para Produção Biológica (PB), assinalar: \nC1 - Primeiro ano de conversão para PB; \nC2 - Segundo ano de conversão para PB; \nC3 - Terceiro ano de conversão para PB."
                      }
                    />
                    Conversão:

                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.2,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    <FormGroup

                      onChange={onInputEditTableChange_cabecalho} >
                      <FormControlLabel
                        name="c1"
                        disabled={!flag_editar_cabecalho}
                        label={
                          <Typography
                            fontFamily="candara"
                            fontSize={16}
                          >
                            C1
                          </Typography>
                        }
                        aria-readonly
                        value={obj_anexo_cabecalho_to_edit?.c1}
                        control={
                          <Checkbox
                            checked={!!obj_anexo_cabecalho_to_edit?.c1}
                            onChange={onInputEditTableChange_cabecalho}
                            name="c1"
                            disabled={!flag_editar_cabecalho}
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": {
                                color: "#C94F1E",
                              },
                            }}
                          />
                        }
                      />
                    </FormGroup>

                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.2,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    <FormGroup

                      onChange={onInputEditTableChange_cabecalho} >
                      <FormControlLabel
                        name="c2"
                        disabled={!flag_editar_cabecalho}
                        label={
                          <Typography
                            fontFamily="candara"
                            fontSize={16}
                          >
                            C2
                          </Typography>
                        }
                        aria-readonly
                        value={obj_anexo_cabecalho_to_edit?.c2}

                        control={
                          <Checkbox
                            checked={!!obj_anexo_cabecalho_to_edit?.c2}
                            onChange={onInputEditTableChange_cabecalho}
                            name="c2"
                            disabled={!flag_editar_cabecalho}
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": {
                                color: "#C94F1E",
                              },
                            }}
                          />
                        }
                      />
                    </FormGroup>


                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.2,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    <FormGroup

                      onChange={onInputEditTableChange_cabecalho} >
                      <FormControlLabel
                        name="c3"
                        disabled={!flag_editar_cabecalho}
                        label={
                          <Typography
                            fontFamily="candara"
                            fontSize={16}
                          >
                            C3
                          </Typography>
                        }
                        aria-readonly
                        value={obj_anexo_cabecalho_to_edit?.c3}

                        control={
                          <Checkbox
                            checked={!!obj_anexo_cabecalho_to_edit?.c3}
                            onChange={onInputEditTableChange_cabecalho}
                            name="c3"
                            disabled={!flag_editar_cabecalho}
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": {
                                color: "#C94F1E",
                              },
                            }}
                          />
                        }
                      />
                    </FormGroup>

                  </div>




                </div>
                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',

                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.3,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    Área (ha): {cultura_selecionada?.area === undefined ? '' : cultura_selecionada?.area.toFixed(2)}

                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.4,
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    flexDirection: 'row',
                    height: 70,
                    gap: 8,
                    border: '1px solid silver',
                    padding: 8,
                    borderRadius: 5,
                  }}>
                    Cultura e variedade:
                    {!isEditingCultura ? (
                      <Select
                        value={cultura_selecionada?.cultura ?? ''}
                        name={'cultura'}
                        sx={{
                          fontSize: 14,
                          fontFamily: "verdana",
                          minWidth: 200,
                        }}
                        onChange={(e) => {
                          handle_change_cultura(e.target.value)
                        }}
                      >
                        {especie_ou_lote_homegenio_selecionada?.culturas
                          .sort((a, b) =>
                            (a?.cultura ?? '').localeCompare(b?.cultura ?? '', 'pt', {
                              sensitivity: 'base',
                            })
                          )
                          .map((item: any, key) => (
                            <MenuItem key={key} value={item.cultura}>
                              <Typography sx={{ fontSize: 14, fontFamily: "candara" }}>
                                {item.cultura}
                              </Typography>
                            </MenuItem>
                          ))}
                      </Select>
                    ) : (
                      <CustomTextField
                        name="cultura"
                        minWidth={200}
                        value={cultura_selecionada?.cultura === undefined ? '' : cultura_selecionada?.cultura}
                        onChange={(e: any) => {

                          set_especie_ou_lote_homegenio_selecionada((old: any) => ({
                            ...old,
                            culturas: old.culturas.map((el: any) => {
                              if (el.cultura === cultura_selecionada?.cultura) {
                                return {
                                  ...el,
                                  cultura: e.target.value,
                                }
                              } else {
                                return el
                              }
                            })
                          }))
                          set_cultura_selecionada((old: any) => ({
                            ...old,
                            cultura: e.target.value,
                          }))
                        }}
                      />
                    )}

                    <div style={{
                      display: "flex"
                      // , alignSelf: "flex-start",
                    }}>
                      {
                        flag_editar_cabecalho === false ? <></> :
                          isEditingCultura ?
                            <ButtonCadernos
                              mostrarBotaoGravar
                              aoClicarGravar={() => { setIsEditingCultura(prev => !prev) }}
                            />
                            :
                            <ButtonCadernos
                              mostrarBotaoEditar

                              aoClicarEditar={() => { setIsEditingCultura(prev => !prev) }}
                            />
                      }


                    </div>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.3,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    <BasicPopover
                      text={
                        "Preencher apenas para cultura permanente"
                      }
                    />
                    Compasso:
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          name="compasso"
                          value={obj_anexo_cabecalho_to_edit?.compasso === undefined ? '' : obj_anexo_cabecalho_to_edit?.compasso}
                          onChange={onInputEditTableChange_cabecalho}

                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.compasso === undefined ? '' : obj_anexo_cabecalho?.compasso}
                        </div>

                    }

                  </div>
                </div>

                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',

                }}>


                  <div style={{
                    display: "flex",
                    flex: 0.3,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    <BasicPopover
                      text={
                        "Preencher apenas para cultura permanente"
                      }
                    />
                    Porta-enxerto:
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          name="porta_enxerto"
                          value={obj_anexo_cabecalho_to_edit?.porta_enxerto === undefined ? '' : obj_anexo_cabecalho_to_edit?.porta_enxerto}
                          onChange={onInputEditTableChange_cabecalho}

                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.porta_enxerto === undefined ? '' : obj_anexo_cabecalho?.porta_enxerto}
                        </div>

                    }
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.3,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    nº de plantas:
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          name="n_planta"
                          value={obj_anexo_cabecalho_to_edit?.n_planta === undefined ? '' : obj_anexo_cabecalho_to_edit?.n_planta}
                          onChange={onInputEditTableChange_cabecalho}
                          error={error_n_planta}
                          helperText={error_n_planta ? 'Apenas números são aceites' : ""}

                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.n_planta === undefined ? '' : obj_anexo_cabecalho?.n_planta}
                        </div>

                    }
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.4,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    <BasicPopover
                      text={
                        "Preencher apenas para cultura permanente"
                      }
                    />
                    Data de plantação ou de sementeira:
                    {
                      flag_editar_cabecalho === true ?
                        <TextField
                          variant="filled"
                          type="date"
                          defaultValue={obj_anexo_cabecalho_to_edit?.data_plantacao}
                          name="data_plantacao"
                          value={obj_anexo_cabecalho_to_edit?.data_plantacao === undefined ? '' : obj_anexo_cabecalho_to_edit?.data_plantacao}
                          onChange={onInputEditTableChange_cabecalho}
                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.data_plantacao === undefined ? '' : obj_anexo_cabecalho?.data_plantacao}
                        </div>

                    }
                  </div>


                </div>
                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',

                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.33,
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    flexDirection: 'row',
                    marginRight: '2%',


                  }}>
                    Produção total:

                  </div>

                  <div style={{
                    display: "flex",
                    flex: 0.33,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',


                  }}>
                    Esperada (Ton/ha):
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          name="esperada"
                          value={obj_anexo_cabecalho_to_edit?.esperada === undefined ? '' : obj_anexo_cabecalho_to_edit?.esperada}
                          onChange={onInputEditTableChange_cabecalho}
                          error={error_esperada}
                          helperText={error_esperada ? 'Apenas números são aceites' : ""}
                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.esperada === undefined ? '' : obj_anexo_cabecalho?.esperada}
                        </div>

                    }

                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.33,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    Obtida (Ton/ha):
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          name="obtida"
                          value={obj_anexo_cabecalho_to_edit?.obtida === undefined ? '' : obj_anexo_cabecalho_to_edit?.obtida}
                          onChange={onInputEditTableChange_cabecalho}
                          error={error_obtida}
                          helperText={error_obtida ? 'Apenas números são aceites' : ""}
                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.obtida === undefined ? '' : obj_anexo_cabecalho?.obtida}
                        </div>

                    }

                  </div>

                </div>

              </div>
            </Toolbar>

          }
        </TableContainer>
      </CustomThemeProvider>
      <ConfirmDialog
        open={open_dialog_tem_a_certeza_que_quer_eliminar}
        onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
        onConfirm={handle_delete_cabecalho}
        message="Deseja eliminar o registo?"
      />
      <ConfirmDialog
        open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
        onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
        onConfirm={() => handleCloseDialog()}
        message={mensagem_tem_a_certeza_de_apagar_alteracoes}
      />
    </form>
  );
};
